























import {Component, Vue, Prop} from "vue-property-decorator";
import LoadingDroppo from "@/views/components/LoadingDroppo.vue";


@Component({
  name: 'OrderCreationLoading',
  components: {
    LoadingDroppo,
  },
})
export default class OrderCreationLoading extends Vue {
}
